import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Toaster } from 'sonner';
import './i18n';
import './index.css';
import { router } from './router';
import { createQueryClient } from './lib/query-client';
import { ErrorBoundary } from './components/error-boundary';
import { ConfirmProvider } from './components/confirm-dialog';
import {
  attachGlobalErrorHandlers,
  initObservability,
  setObservabilityUser,
} from './lib/observability';
import { initTheme } from './lib/stores/ui-store';
import { useAuthStore } from './lib/stores/auth-store';

initObservability();
attachGlobalErrorHandlers();
initTheme();

// Mirror the authenticated admin into Sentry's user context. We only send the
// stable identifier + email so the audit trail is meaningful but PII stays
// minimal. Cleared on logout.
useAuthStore.subscribe((state) => {
  setObservabilityUser(state.user ? { id: state.user.id, email: state.user.email } : null);
});

const queryClient = createQueryClient();

const root = document.getElementById('root');
if (!root) throw new Error('root element missing');

createRoot(root).render(
  <StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <ConfirmProvider>
          <RouterProvider router={router} />
          <Toaster richColors closeButton />
        </ConfirmProvider>
        {import.meta.env.DEV ? <ReactQueryDevtools initialIsOpen={false} /> : null}
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>,
);
